/*
 * shop5-locations.js - the Share buttons of the owner's standalone branches page (rules section 19, stage 6J, UQ28
 * decision 8; sections/shop5-locations.liquid). Loaded with defer by snippets/shop5-locations-head.liquid on that page
 * only; no dependencies, no outside script.
 *
 * A Share button ([data-shop5-loc-share]) opens the system share sheet with the branch name and its map link where the
 * browser has one. Without it, or when the sheet fails for another reason than the visitor closing it, the map link is
 * copied and the page's role=status region ([data-shop5-loc-toast]) shows the design's message ("Branch link copied",
 * its data-text) for 1.8 s: the message is a new element put in the region, so each copy is announced again, and it is
 * taken out after 1.8 s. A copy the browser refuses shows no message.
 */
(function () {
  'use strict';

  var region = document.querySelector('[data-shop5-loc-toast]');
  var timer = 0;

  var flash = function () {
    var text = region ? region.getAttribute('data-text') : '';
    if (!region || !text) return;
    window.clearTimeout(timer);
    while (region.firstChild) region.removeChild(region.firstChild);
    var pill = document.createElement('div');
    pill.className = 'shop5-loc__toast';
    pill.textContent = text;
    region.appendChild(pill);
    timer = window.setTimeout(function () {
      if (pill.parentNode) pill.parentNode.removeChild(pill);
    }, 1800);
  };

  var copy = function (url) {
    if (!navigator.clipboard || !navigator.clipboard.writeText) return;
    navigator.clipboard.writeText(url).then(flash, function () {});
  };

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-shop5-loc-share]') : null;
    if (!button) return;
    var name = button.getAttribute('data-name') || document.title;
    var url = button.getAttribute('data-url') || window.location.href;
    if (navigator.share) {
      navigator.share({ title: name, text: name, url: url }).catch(function (error) {
        if (error && error.name === 'AbortError') return;
        copy(url);
      });
      return;
    }
    copy(url);
  });
})();
